import { render } from "./Header.vue?vue&type=template&id=5b27f5e8&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "@/styles/header.css?vue&type=style&index=0&id=5b27f5e8&scoped=true&lang=css&external"
import "@/styles/footer.css?vue&type=style&index=1&id=5b27f5e8&scoped=true&lang=css&external"
import "@/styles/common.css?vue&type=style&index=2&id=5b27f5e8&scoped=true&lang=css&external"
import "./Header.vue?vue&type=style&index=3&id=5b27f5e8&lang=css"

import exportComponent from "../../../../../../../../../../../../private/tmp/codex-user-modern-deps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b27f5e8"]])

export default __exports__